import { EXPERIMENT_NAME } from './index';
import { evaluateAndLogExperiment, getBucketValueByExperimentName } from 'utility';
import { ContextStore, ExperimentStore, PageStore } from 'bernie-plugin-mobx';

export const logMetaExperiment = {
  isMetaExperimentEnabled: (experiment: ExperimentStore): boolean => {
    return getBucketValueByExperimentName(experiment, EXPERIMENT_NAME) == 1;
  },
  logExperiment: (context: ContextStore, experiment: ExperimentStore, page: PageStore): void => {
    evaluateAndLogExperiment(experiment, EXPERIMENT_NAME, context, page);
  }
};
